import {API_DRIVER} from "../config/axios";
import {DocumentType} from "../util/constants";

const getDocumentsRequestUrl = (endpointUrl: string) => {
    return `/api/documents${endpointUrl}`
}

export interface IDocumentCreate {
    name: string
    content_en: string
    content_mk: string
    content_al: string
    additional_information?: string
}

const DocumentService = {
    fetchLatestDocuments: () => {
        return API_DRIVER.get(getDocumentsRequestUrl(``))
    },
    fetchLatestDocumentByName: (name: DocumentType) => {
        return API_DRIVER.get(getDocumentsRequestUrl(`/${name}`))
    },
    createDocument: (body: IDocumentCreate) => {
        return API_DRIVER.post(getDocumentsRequestUrl(``), body)
    },
    fetchDocumentHistoryByName: (name: DocumentType) => {
        return API_DRIVER.get(getDocumentsRequestUrl(`/${name}/history`))
    },
}

export default DocumentService
